export const GET_COIN = "GET_COIN";